import { z } from 'zod';
/**
 * 📄 I DOCUMENTI DEL BOT (voce 37, 27/09/2026, mockup approvato: «37 AAA»).
 * 🗣️ *«un indirizzo nascosto, tipo, dove possiamo pubblicare i documenti che la
 * gente poi vede sul bot»*.
 *
 * Due documenti, scritti nel gestionale da chi può modificare le impostazioni e
 * pubblicati a un indirizzo che non si indovina, solo da leggere:
 *   · il **regolamento** del circolo (🔄 30/09/2026: era quello dell'acconto
 *     della sera, che il bot faceva accettare; l'acconto non c'è più);
 *   · l'**informativa privacy**.
 *
 * ⚖️ Nascosto non vuol dire protetto: chi riceve il link lo può inoltrare. Va
 *    bene per due testi fatti apposta per essere letti; qui dentro non ci va
 *    niente di riservato.
 */
export const TIPI_DOCUMENTO = ['regolamento', 'privacy'];
export const tipoDocumentoSchema = z.enum(TIPI_DOCUMENTO);
export const TITOLI_DOCUMENTO = {
    regolamento: 'Regolamento',
    privacy: 'Informativa privacy',
};
/**
 * Pubblicare. `nuovaVersione` è la scelta che conta per i soci:
 *   · `false` ⇒ **correzione**: un errore di battitura, niente che cambi le
 *     regole. Il numero resta quello, e chi l'ha accettato non riaccetta;
 *   · `true` ⇒ **versione nuova**: il numero sale, e il bot lo fa riaccettare
 *     a tutti prima della loro prossima partita della sera.
 */
export const pubblicoUnDocumentoSchema = z.object({
    testo: z
        .string()
        .trim()
        .min(20, 'Il testo è troppo corto: almeno qualche riga')
        .max(20000, 'Il testo è troppo lungo: al massimo 20.000 caratteri'),
    nuovaVersione: z.boolean(),
});
export const versioneDelDocumentoSchema = z.object({
    versione: z.number().int(),
    /** 0 per la versione, 1, 2… per le correzioni che le sono venute dopo. */
    correzione: z.number().int(),
    pubblicatoIl: z.string(),
    daChi: z.string().nullable(),
});
export const documentoSchema = z.object({
    tipo: tipoDocumentoSchema,
    titolo: z.string(),
    /** L'indirizzo nascosto; `null` finché non si è pubblicato niente. */
    indirizzo: z.string().nullable(),
    versione: z.number().int().nullable(),
    pubblicatoIl: z.string().nullable(),
    /** Il testo in vigore (vuoto se non c'è ancora). */
    testo: z.string(),
    /** Dalla più recente alla più vecchia. */
    storia: z.array(versioneDelDocumentoSchema),
});
export const documentiSchema = z.object({ items: z.array(documentoSchema) });
/**
 * Com'è andata una pubblicazione. `avviso` c'è quando il documento è in linea
 * ma le impostazioni non si sono potute riempire (l'indirizzo non è https:
 * il bot non lo mostrerebbe).
 */
export const documentoPubblicatoSchema = z.object({
    documento: documentoSchema,
    avviso: z.string().nullable(),
});
const ESCAPE = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};
const scappa = (t) => t.replace(/[&<>"']/g, (c) => ESCAPE[c]);
/**
 * Il testo scritto in segreteria diventa HTML, con due sole regole che si
 * spiegano in una riga sotto la casella:
 *   · una riga che comincia con `#` è un titolo;
 *   · una riga vuota va a capo (nuovo paragrafo).
 *
 * 🔒 **Prima l'escape, poi le regole**: il testo lo scrive una persona, e la
 *    pagina la apre un socio. Un `<script>` scritto nella casella resta testo.
 */
export function testoInHtml(testo) {
    const pezzi = [];
    let paragrafo = [];
    const chiudi = () => {
        if (paragrafo.length > 0)
            pezzi.push(`<p>${paragrafo.join(' ')}</p>`);
        paragrafo = [];
    };
    for (const grezza of testo.replace(/\r\n?/g, '\n').split('\n')) {
        const riga = grezza.trim();
        if (riga === '') {
            chiudi();
        }
        else if (riga.startsWith('#')) {
            chiudi();
            const titolo = riga.replace(/^#+\s*/, '');
            if (titolo !== '')
                pezzi.push(`<h2>${scappa(titolo)}</h2>`);
        }
        else {
            paragrafo.push(scappa(riga));
        }
    }
    chiudi();
    return pezzi.join('\n');
}
//# sourceMappingURL=documenti.js.map